/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetEvaluate, SaveEvaluate } from '@/api/miniClinic';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import '@/store/mutation_types';
import msgImg from '@/resources/images/eva/msg.png';
export default {
  data: function data() {
    return {
      detailList: [],
      isEdit: false,
      list: [1, 2, 3, 4, 5],
      message: '',
      status: 1,
      msgImg: msgImg,
      acographyId: '',
      flag: true
    };
  },
  created: function created() {
    var _this = this;

    this.acographyId = this.$router.currentRoute.query.acographyId;
    GetEvaluate(this.acographyId).then(function (data) {
      if (!data) {
        return;
      }

      if (data.status) {
        _this.status = 2;
      } else {
        _this.detailList = data;
      }

      console.log(data);
    }); // this.acographyId = "8aa5dc97bd4a4b15b25d97aa16e2cd54";
  },
  mounted: function mounted() {},
  computed: _objectSpread({}, mapGetters({})),
  methods: {
    starClick: function starClick(item, dIndex) {
      var dList = this.detailList;

      if (dList[dIndex]) {
        dList[dIndex].score = item;
        this.detailList = dList;
      }
    },
    submitForm: function submitForm() {
      var _this2 = this;

      var param = {};
      var detailList = this.detailList,
          detail = [],
          tmp = {};
      var len = detailList.length,
          score = 0,
          message = this.message; // let date = new Date();
      // date = 
      // param.detail = this.detailList;

      var _iterator = _createForOfIteratorHelper(detailList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          tmp = {};
          tmp.score = item.score;
          tmp.evaluateSetId = item.evaluateSetId;
          detail.push(tmp);
          score += item.score;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      detail = detailList;
      score = parseFloat(score / len).toFixed(1);
      detail = JSON.stringify(detail);

      if (message && message.length > 100) {
        Public.tips({
          text: '最多不超过100个字'
        });
        return;
      }

      if (!this.flag) {
        return;
      }

      this.flag = false;
      param = {
        detail: detail,
        score: score,
        message: message,
        acographyId: this.acographyId
      };
      SaveEvaluate(param).then(function (data) {
        _this2.flag = true;
        _this2.status = 2;
      });
    }
  }
};